import { IErrorDefinition } from '@shared/types';
import { isString, get } from 'lodash';

export class XVIError extends Error implements IErrorDefinition {
  public message: string = null;
  public code: string = null;

  public constructor(error?: IErrorDefinition | string) {
    super();

    if (error instanceof XVIError) return error;

    if (isString(error)) {
      this.message = error;

      return;
    }

    this.message = get(error, 'message', null);
    this.code = get(error, 'code', null);
  }
}
